import React from 'react';
import PropTypes from 'prop-types';

export const KILLER_STEPS = [
    { id: 1, label: 'Список' },
    { id: 2, label: 'Фотографии' },
    { id: 3, label: 'Сгенерировать' },
    { id: 4, label: 'Скачать' }
];

// Степпер генерации Киллера: 4 шага (done/active/lock) + коннекторы.
export default function KillerStepper({ status, onStep }) {
    return (
        <div className="kstepper">
            {KILLER_STEPS.map((step, index) => {
                const done = status > step.id;
                const active = status === step.id;
                const cls = done ? 'kstep done' : active ? 'kstep active' : 'kstep lock';
                const disabled = step.id > status + 1;
                return (
                    <React.Fragment key={step.id}>
                        <div className={cls}>
                            <div className="circ">{step.id}</div>
                            <button type="button" className="kbtn" onClick={() => onStep(index)} disabled={disabled}>
                                {step.label}
                            </button>
                        </div>
                        {index < KILLER_STEPS.length - 1 && <div className={`kconn${done ? ' done' : ''}`} />}
                    </React.Fragment>
                );
            })}
        </div>
    );
}

KillerStepper.propTypes = {
    status: PropTypes.number.isRequired,
    onStep: PropTypes.func.isRequired
};
